export default __webpack_public_path__ + "static/Sticker_A5_USERS-1fcdbf72709d73e837b7a76b05c2dbf0.svg";